<template>
  <div class="container" v-show="isShow">
    <a class="popup-close-button" @click="showLEDHostList">x</a>
    <div class="content">
        <div class="containerBody" v-for="(option,index) in options" :key="index" 
            @click="flyToThisLedHostCoord( option.gprsAddr)">
            <div class="containerLeft" ><img class="image" :src="option.img"></div>
            <div class="containerContext" >
                <table class="table">
                    <tr><th class="tableTh" scope="col" colspan="4">{{ option.name }}</th></tr>
                    <tr><td>路段：</td><td>{{ option.road }}</td></tr>
                    <tr><td>经度：</td><td>{{ option.lng }}</td></tr>
                    <tr><td>纬度：</td><td>{{ option.lat }}</td></tr>
                    <tr><td>工作模式：</td><td>{{ option.workMode }}</td></tr>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import imgLedOn from '../assets/LedOn.png'
import imgLedOff from '../assets/Led.png'
export default {
    name:'DisplayLEDHostList',
    data(){
        return {
            isShow:false,
            viewer:'',
            ledHostListDatas:[],
            options:[],
        }
    },
    methods:{
        LEDHostListDatas(ledDatas){
            console.log('DisplayLEDHostList组件 接收到LEDHostList数据:',ledDatas);
            let gprsAddr ,img ,name ,road ,lng ,lat ,workMode ;
            let work = ["手动模式","时区模式","轮廓加强","主动诱导","防碰撞","自动模式","偶黄奇红","偶红奇黄","全红模式","测试模式"];
            this.ledHostListDatas = ledDatas ;
         
            this.ledHostListDatas.forEach((element)=>{
                if(element.online){    img = imgLedOn ;    }
                else{   img = imgLedOff ; }
                gprsAddr = element.gprsAddr ;
                name = element.name ;
                road = element.road ;
                lng = element.lon.toFixed(6) ;
                lat = element.lat.toFixed(6) ;
                workMode = work[element.mode] ;
                this.options.push({gprsAddr,img,name,road,lng,lat,workMode});
                // console.log('this,$nextTick ',element.name)
            })
                 
             
            
        },
        flyToThisLedHostCoord(gprsAddr){
            console.log('flyToThisLedHostCoord e = ', gprsAddr);
            this.ledHostListDatas.forEach((element)=>{
                if(element.gprsAddr == gprsAddr){
                    this.viewer.camera.flyTo({                        
                        destination: Cesium.Cartesian3.fromDegrees(element.lon-0.5,element.lat-0.01, 1000),
                        orientation: {
                            heading: 0.43,// Cesium.Math.toRadians(0),
                            pitch: -0.95,//Cesium.Math.toRadians(-90),
                            roll: 6.28
                        },
                        duration: 3 //3秒到达战场
                    }); 
                }
            })
        },
        getViewer(viewer){
            this.viewer = viewer ;
        },
        showLEDHostList(){
            this.isShow = !this.isShow ;
        }
    },
    mounted(){
        this.$bus.on('getViewer',this.getViewer);
        this.$bus.on('LEDHostListDatas',this.LEDHostListDatas); 
        this.$bus.on('showLEDHostList',this.showLEDHostList);  
    },
    unmounted(){
        this.$bus.off('getViewer');
        this.$bus.off('LEDHostListDatas');
    }
}
</script>

<style scoped>
.container{
    position: absolute;
    width: 320px;
    height: 740px;
    margin-top: 1%;
    margin-left: 0.5%;
    border-radius: 10px;
    background-color: rgba(0,0 ,0 ,0.8 );
    
    padding-bottom: 0.4%;
    border: 1px solid white;
}
.content{
    margin-top: 8%;
    width: 100%;
    height: 96%;
    overflow: scroll;
}
.containerBody{
    width: 94%;
    height: 150px;
    margin-top: 8px;
    margin-left: 3%;
    text-align: center;
    cursor: pointer;
    background-color: rgba(255,255,255,0.3);
    border-radius: 5px;
    
}
.containerBody:hover{
    background-color: rgba(255,255,255,0.5);
}
.containerLeft{
    float: left;
    width: 20%;
    height: 100%;
    text-align: center;
}
.image{
    width: 80%;
    height: 50%;
    margin-left: 5%;
    margin-top: 40%;
}
.containerContext{
    width: 70%;
    height: 100%;
    margin-left: 20%;
}
.table{
    width: 200px;
    color: white;
    font-size: 0.9em;
}
.tableTh{
    text-align: center;
    font-size: 15px;
}


.popup-close-button {
    position: absolute;
    top: 0;
    right: 14px;
    padding: 5px 10px 0 0;
    text-align: center;
    width: 18px;
    height: 14px;
    font: 20px/16px Tahoma, Verdana, sans-serif;
    text-decoration: none;
    font-weight: 700;
    background: transparent;
    z-index: 9999;
    color: aliceblue;
  }

  .popup-close-button:hover {
    cursor: pointer;
    color: red;
  }
</style>